"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputRow = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var theme_1 = require("../theme");

exports.InputRow = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-grid;\n  grid-auto-flow: column;\n  div.label {\n    grid-row: 1;\n    padding: 0 4px;\n    font-size: 12px;\n    font-weight: 500;\n    color: ", ";\n  }\n  div.input {\n    grid-row: 2;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &.with-background {\n      box-shadow: inset 0 0 0 1px ", ";\n      background: ", ";\n    }\n  }\n  & > div > div,\n  & > div > label {\n    display: grid;\n    grid-auto-flow: row;\n    grid-template-rows: repeat(2, 1fr);\n    align-items: end;\n    height: 100%;\n  }\n  input,\n  button {\n    border-radius: 0;\n  }\n  button {\n    width: 100%;\n    height: 100%;\n  }\n  & > div:first-of-type input,\n  & > div:first-of-type button {\n    border-radius: 0.25em 0 0 0.25em;\n  }\n  & > div:last-of-type input,\n  & > div:last-of-type button {\n    border-radius: 0 0.25em 0.25em 0;\n  }\n\n  @media (max-width: 45em) {\n    grid-auto-flow: row;\n  }\n"])), theme_1.theme.colors.gray[900], theme_1.theme.colors.white[500], theme_1.theme.colors.white[800]);